import { Injectable } from "@angular/core";
import { Temporal } from "@js-temporal/polyfill";
import { Intervention } from "src/app/domain/intervention";
import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { InterventionEntity } from "../intervention.entity";
import { AppareilRepository } from "./appareil.repository";
import { CanalRepository } from "./canal.repository";
import { EndoscopeRepository } from "./endoscope.repository";
import { GenerateurRepository } from "./generateur.repository";
import { PrelevementAirRepository } from "./prelevement-air.repository";
import { PrelevementGenerateurRepository } from "./prelevement-generateur.repository";
import { PrelevementSurfaceRepository } from "./prelevement-surface.repository";
import { PrelevementRepository } from "./prelevement.repository";
import { QualifSalleRepository } from "./qualif-salle.repository";
import { UserRepository } from "./user.repository";
import { ZoneRepository } from "./zone.repository";
import { ETaskStatus } from "src/app/models/enums/task-status";

@Injectable({
    providedIn: 'root',
})
export class InterventionRepository {
    constructor(
        private userRepository: UserRepository,
        private endoscopeRepository: EndoscopeRepository,
        private zoneRepository: ZoneRepository,
        private generateurRepository: GenerateurRepository,
        private prelevementRepository: PrelevementRepository,
        private prelevementAirRepository: PrelevementAirRepository,
        private prelevementSurfaceRepository: PrelevementSurfaceRepository,
        private prelevementGenerateurRepository: PrelevementGenerateurRepository,
        private qualifSalleRepository: QualifSalleRepository,
        private appareilRepository: AppareilRepository,
        private canalRepository: CanalRepository
    ) { }

    async changeInterventionStatus(int: Intervention) {
        const ie = await this.getInterventionEntityByCode(int.Code)
        if (!ie || !ie.Id) {
            return;
        }
        await db.interventions.update(ie.Id, {
            Status: int.Status
        });
        return true;
    }

    async addIntervention(int: Intervention) {

        await db.transaction('rw', [
            db.interventions, db.users,
            db.zones, db.prelevementAirs, db.prelevementSurfaces,
            db.prelevementGenerateurs, db.generateurs,
            db.prelevements, db.samplingPoints, db.flacons,
            db.endoscopes, db.canals, db.prelevementQualifSalles, db.appareils,
            db.soufflages, db.reprises, db.zoneCompares], async () => {
                const ie = mapper.map(int, Intervention, InterventionEntity);

                ie.Id = await db.interventions.add(ie);
                // if (int.SamplingPoint) {
                //     await this.attachSamplingPoint(int.SamplingPoint, interventionId);
                // }

                if (int.Sampler) {
                    await this.userRepository.attachUser(int.Sampler, ie, true);
                }

                // if (int?.Biocollecteur) {
                //     await this.appareilRepository.attachAppareilToIntervention(int?.Biocollecteur, ie.Id)
                // }
                // if (int?.ApplicateurContact) {
                //     await this.appareilRepository.attachAppareilToIntervention(int?.ApplicateurContact, ie.Id)
                // }
                // if (int?.Multimetre) {
                //     await this.appareilRepository.attachAppareilToIntervention(int?.Multimetre, ie.Id)
                // }
                // if (int?.Compteur) {
                //     await this.appareilRepository.attachAppareilToIntervention(int?.Compteur, ie.Id)
                // }
                // if (int.Contact) {
                //     await this.attachUser(int.Contact, interventionId, false);
                // }
                for (let i = 0; i < int.ZoneList.length; i++) {
                    await this.zoneRepository.attachZone(int.ZoneList[i], ie);
                }

                for (let i = 0; i < int.GenerateurDialyseList.length; i++) {
                    await this.generateurRepository.attachGenerateur(int.GenerateurDialyseList[i], ie);
                }

                for (let i = 0; i < int.EndoscopeList.length; i++) {
                    await this.endoscopeRepository.attachEndoscope(int.EndoscopeList[i], ie);
                }

                return ie.Id;
            })
    }

    async getInterventionEntityById(id: number) {
        return await db.interventions.where('Id').equals(id).first(async ie => {
            return ie;
        });
    }

    async getInterventionEntityByCode(code: string) {
        return await db.interventions.where('Code').equals(code).first(async ie => {
            return ie;
        });
    }

    async getInterventionList() {
        const interventionList: Intervention[] = [];
        let list = db.interventions.toCollection();
        await list.each(x => {
            const intervention = mapper.map(x, InterventionEntity, Intervention);
            interventionList.push(intervention);
        })

        // const interventionList = await Promise.all(
        //     await db.interventions.toArray(ies => {
        //         return ies.map(async ie => {
        //             // const intervention = mapper.map(ie, InterventionEntity, Intervention);
        //             // if (ie?.SamplingPointId) {
        //             //     intervention.SamplingPoint = await this.getSamplingPointById(ie.SamplingPointId);
        //             // }
        //             const intervention = await this.getInterventionByCode(ie.Code);
        //             return intervention;
        //         });
        //     })
            
        // );
        return interventionList;
    }

    async getInterventionByCode(code: string) {
        return await db.interventions.where('Code').equals(code).first(async ie => {
            const intervention = mapper.map(ie, InterventionEntity, Intervention);

            // if (ie?.BiocollecteurId) {
            //     intervention.Biocollecteur = await this.appareilRepository.getAppareilById(ie?.BiocollecteurId)
            // }
            // if (ie?.ApplicateurContactId) {
            //     intervention.ApplicateurContact = await this.appareilRepository.getAppareilById(ie?.ApplicateurContactId)
            // }
            // if (ie?.MultimetreId) {
            //     intervention.Multimetre = await this.appareilRepository.getAppareilById(ie?.MultimetreId)
            // }
            // if (ie?.CompteurId) {
            //     intervention.Compteur =await this.appareilRepository.getAppareilById(ie?.CompteurId)
            // }

            console.log('ZONE S ' + Temporal.Now.plainDateTimeISO().toJSON())
            if (ie?.ZoneIds) {
                for (let i = 0; i < ie.ZoneIds.length; i++) {
                    intervention.ZoneList.push(await this.zoneRepository.getZoneById(ie.ZoneIds[i]));
                }
            }
            console.log('ZONE E ' + Temporal.Now.plainDateTimeISO().toJSON())

            console.log('GENERATEUR S ' + Temporal.Now.plainDateTimeISO().toJSON())
            if (ie?.GenerateurIds) {
                for (let i = 0; i < ie?.GenerateurIds.length; i++) {
                    intervention.GenerateurDialyseList.push(await this.generateurRepository.getGenerateurById(ie?.GenerateurIds[i]));
                }
            }
            console.log('GENERATEUR E' + Temporal.Now.plainDateTimeISO().toJSON())

            console.log('ENDOSCOPE S ' + Temporal.Now.plainDateTimeISO().toJSON())
            if (ie?.EndoscopeIds) {
                for (let i = 0; i < ie?.EndoscopeIds.length; i++) {
                    intervention.EndoscopeList.push(await this.endoscopeRepository.getEndoscopeById(ie?.EndoscopeIds[i]));
                }
            }
            console.log('ENDOSCOPE E ' + Temporal.Now.plainDateTimeISO().toJSON())


            console.log('=========================')
            return intervention;
        })
    }

    async getInterventionListWithZoneOnly() {

        console.log(Temporal.Now.plainDateISO().toJSON())

        const interventionList = await Promise.all(

            await db.interventions.toArray(ies => {
                return ies.map(async ie => {

                    const intervention = await this.getInterventionByCodeWithZoneOnly(ie.Id!);
                    return intervention;

                });
            })
        );
        return interventionList;
    }

    async getInterventionByCodeWithZoneOnly(id: number) {
        return await db.interventions.where('Id').equals(id).first(async ie => {
            const intervention = mapper.map(ie, InterventionEntity, Intervention);

            if (ie?.ZoneIds) {
                for (let i = 0; i < ie.ZoneIds.length; i++) {
                    let zone = await this.zoneRepository.getZoneById(ie.ZoneIds[i])
                    if (zone.TaskStatus !== ETaskStatus.Done)
                        intervention.ZoneList.push(zone);
                }
            }

            return intervention;
        })
    }

    async getInterventionListWithEndoscopeOnly() {
        const interventionList = await Promise.all(
            await db.interventions.toArray(ies => {
                return ies.map(async ie => {
                    // const intervention = mapper.map(ie, InterventionEntity, Intervention);
                    // if (ie?.SamplingPointId) {
                    //     intervention.SamplingPoint = await this.getSamplingPointById(ie.SamplingPointId);
                    // }
                    const intervention = await this.getInterventionByCodeWithEndoscopeOnly(ie.Id!);
                    return intervention;
                });
            })
        );
        return interventionList;
    }

    async getInterventionByCodeWithEndoscopeOnly(id: number) {
        return await db.interventions.where('EndoscopeIds').equals(id).and(x => { return Temporal.PlainDate.from(x.PlannedDate) === Temporal.Now.plainDateISO() }).first(async ie => {
            const intervention = mapper.map(ie, InterventionEntity, Intervention);

            if (ie?.EndoscopeIds) {
                for (let i = 0; i < ie?.EndoscopeIds.length; i++) {
                    let endoscope = await this.endoscopeRepository.getEndoscopeById(ie?.EndoscopeIds[i])
                    if (endoscope.TaskStatus !== ETaskStatus.Done)
                        intervention.EndoscopeList.push(endoscope);
                }
            }
            return intervention;
        })
    }

    async getInterventionListWithGenerateurOnly() {
        const interventionList = await Promise.all(
            await db.interventions.toArray(ies => {
                return ies.map(async ie => {
                    // const intervention = mapper.map(ie, InterventionEntity, Intervention);
                    // if (ie?.SamplingPointId) {
                    //     intervention.SamplingPoint = await this.getSamplingPointById(ie.SamplingPointId);
                    // }
                    const intervention = await this.getInterventionByCodeWithGenerateurOnly(ie.Id!);
                    return intervention;
                });
            })
        );
        return interventionList;
    }

    async getInterventionByCodeWithGenerateurOnly(id: number) {
        return await db.interventions.where('GenerateurIds').equals(id).and(x => { return Temporal.PlainDate.from(x.PlannedDate) === Temporal.Now.plainDateISO() }).first(async ie => {
            const intervention = mapper.map(ie, InterventionEntity, Intervention);

            if (ie?.GenerateurIds) {
                for (let i = 0; i < ie?.GenerateurIds.length; i++) {
                    intervention.GenerateurDialyseList.push(await this.generateurRepository.getGenerateurById(ie?.GenerateurIds[i]));
                }
            }
            return intervention;
        })
    }

    async getInterventionByZoneCode(code: string) {
        const z = await this.zoneRepository.getZoneEntityByCode(code)
        if (z && z.Id)
            return await db.interventions.where('ZoneIds').equals(z.Id).first(async ie => {
                const intervention = mapper.map(ie, InterventionEntity, Intervention);
                return intervention;
            });

        return undefined;
    }

    async getInterventionByAppareilCode(code: string) {
        const z = await this.generateurRepository.getGenerateurEntityByCode(code)
        if (z && z.Id)
            return await db.interventions.where('GenerateurIds').equals(z.Id).first(async ie => {
                const intervention = mapper.map(ie, InterventionEntity, Intervention);
                return intervention;
            });

        return undefined;
    }

    async getInterventionByEndoscopeCode(code: string) {
        const z = await this.endoscopeRepository.getEndoscopeEntityByCode(code)
        if (z && z.Id)
            return await db.interventions.where('GenerateurIds').equals(z.Id).first(async ie => {
                const intervention = mapper.map(ie, InterventionEntity, Intervention);
                return intervention;
            });

        return undefined;
    }

    async deleteIntervention(code: string) {
        await db.interventions.where('Code').equals(code).first(async ie => {

            // if (ie?.SamplingPointId) {
            //     await db.samplingPoints.where('Id').equals(ie?.SamplingPointId).delete();
            // }
            if (ie?.ZoneIds && ie?.ZoneIds?.length > 0) {
                for (let i = 0; i < ie.ZoneIds.length; i++) {

                    await db.zones.where('Id').equals(ie.ZoneIds[i]).toArray(async zes => {
                        if (!zes)
                            return;
                        for (let j = 0; j < zes.length; j++) {
                            const ze = await this.zoneRepository.getZoneEntityById(zes[j].Id!)

                            if (ze?.PrelevementQualifSalleId) {
                                const qse = await this.qualifSalleRepository.getQualifSalleEntityById(ze?.PrelevementQualifSalleId!);
                                // for (let q = 0; q < qse?.AppareilIds?.length!; q++) {
                                //     await db.appareils.where('Id').equals(qse?.AppareilIds![q]!).delete();
                                // }
                                await db.prelevementQualifSalles.where('Id').equals(qse?.Id!).delete();
                            }

                            for (let m = 0; m < ze?.PrelevementAirIds?.length!; m++) {
                                const pae = await this.prelevementAirRepository.getPrelevementAirEntityById(ze?.PrelevementAirIds[m]!);

                                const pe = await this.prelevementRepository.getPrelevementEntityById(pae?.PrelevementId!);

                                for (let c = 0; c < pe?.ConsommableIds?.length!; c++) {
                                    await db.consommables.where('Id').equals(pe?.ConsommableIds[c]!).delete();
                                }

                                for (let f = 0; f < pe?.FlaconIds?.length!; f++) {
                                    await db.flacons.where('Id').equals(pe?.FlaconIds[f]!).delete();
                                }

                                await db.samplingPoints.where('Id').equals(pe?.SamplingPointId!).delete();
                                await db.prelevements.where('Id').equals(pae?.PrelevementId!).delete();
                                await db.prelevementAirs.where('Id').equals(pae?.Id!).delete();
                            }

                            for (let m = 0; m < ze?.PrelevementSurfaceIds?.length!; m++) {
                                const pse = await this.prelevementSurfaceRepository.getPrelevementSurfaceEntityById(ze?.PrelevementSurfaceIds[m]!);

                                const pe = await this.prelevementRepository.getPrelevementEntityById(pse?.PrelevementId!);

                                for (let c = 0; c < pe?.ConsommableIds?.length!; c++) {
                                    await db.consommables.where('Id').equals(pe?.ConsommableIds[c]!).delete();
                                }

                                for (let f = 0; f < pe?.FlaconIds?.length!; f++) {
                                    await db.flacons.where('Id').equals(pe?.FlaconIds[f]!).delete();
                                }

                                await db.samplingPoints.where('Id').equals(pe?.SamplingPointId!).delete();
                                await db.prelevements.where('Id').equals(pse?.PrelevementId!).delete();
                                await db.prelevementSurfaces.where('Id').equals(pse?.Id!).delete();
                            }

                            await db.zones.where('Id').equals(ze?.Id!).delete();
                        }
                    })
                }
            }

            if (ie?.GenerateurIds && ie?.GenerateurIds?.length > 0) {
                for (let i = 0; i < ie.GenerateurIds.length; i++) {

                    await db.generateurs.where('Id').equals(ie.GenerateurIds[i]).toArray(async aes => {
                        if (!aes)
                            return;
                        for (let j = 0; j < aes.length; j++) {
                            const ae = await this.generateurRepository.getGenerateurEntityById(aes[j].Id!)

                            for (let m = 0; m < ae?.PrelevementGenerateurDialyseIds?.length!; m++) {
                                const ge = await this.prelevementGenerateurRepository.getPrelevementGenerateurEntityById(ae?.PrelevementGenerateurDialyseIds[m]!);

                                const pe = await this.prelevementRepository.getPrelevementEntityById(ge?.PrelevementId!);

                                for (let c = 0; c < pe?.ConsommableIds?.length!; c++) {
                                    await db.consommables.where('Id').equals(pe?.ConsommableIds[c]!).delete();
                                }

                                for (let f = 0; f < pe?.FlaconIds?.length!; f++) {
                                    await db.flacons.where('Id').equals(pe?.FlaconIds[f]!).delete();
                                }

                                await db.samplingPoints.where('Id').equals(pe?.SamplingPointId!).delete();
                                await db.prelevements.where('Id').equals(ge?.PrelevementId!).delete();
                                await db.prelevementGenerateurs.where('Id').equals(ge?.Id!).delete();
                            }

                            await db.generateurs.where('Id').equals(ae?.Id!).delete();
                        }

                    })
                }
            }

            if (ie?.BiocollecteurId) {
                await db.appareils.where('Id').equals(ie?.BiocollecteurId).delete();
            }
            if (ie?.ApplicateurContactId) {
                await db.appareils.where('Id').equals(ie?.ApplicateurContactId).delete();
            }
            if (ie?.CompteurId) {
                await db.appareils.where('Id').equals(ie?.CompteurId).delete();
            }
            if (ie?.MultimetreId) {
                await db.appareils.where('Id').equals(ie?.MultimetreId).delete();
            }

            if (ie?.EndoscopeIds && ie.EndoscopeIds?.length > 0) {
                for (let i = 0; i < ie.EndoscopeIds.length; i++) {
                    await db.endoscopes.where('Id').equals(ie.EndoscopeIds[i]).toArray(async ees => {
                        if (!ees)
                            return;

                        const ee = await this.endoscopeRepository.getEndoscopeEntityById(ees[i].Id!)

                        for (let m = 0; m < ee?.CanalIds?.length!; m++) {
                            const ce = await this.canalRepository.getCanalEntityById(ee?.CanalIds[m]!);

                            const pe = await this.prelevementRepository.getPrelevementEntityById(ce?.PrelevementId!);

                            for (let c = 0; c < pe?.ConsommableIds?.length!; c++) {
                                await db.consommables.where('Id').equals(pe?.ConsommableIds[c]!).delete();
                            }

                            for (let f = 0; f < pe?.FlaconIds?.length!; f++) {
                                await db.flacons.where('Id').equals(pe?.FlaconIds[f]!).delete();
                            }

                            await db.samplingPoints.where('Id').equals(pe?.SamplingPointId!).delete();
                            await db.prelevements.where('Id').equals(ce?.PrelevementId!).delete();
                            await db.canals.where('Id').equals(ce?.Id!).delete();
                        }

                        await db.endoscopes.where('Id').equals(ee?.Id!).delete();
                    })
                }
            }

            await db.interventions.where('Code').equals(code).delete();
        })
    }
}